// Single-source kind vocabulary for /manage/schedule. Three surfaces
// read these tables (FilterStrip dots, ScheduleLegend swatches,
// CalendarEventChip leading type dot) — extracting here means a
// colour or label swap can never desync across the three.
//
// Variation is deliberately absent: the schedule no longer surfaces
// variations (no due-date to track). Milestone uses fuchsia, not
// emerald, so milestone's tag colour cannot be confused with an
// emerald "success" status colour anywhere on the page.

export const SCHEDULE_KINDS = [
  "insurance",
  "deliverable",
  "milestone",
  "meeting",
  "kpi",
] as const;

export type ScheduleKind = (typeof SCHEDULE_KINDS)[number];

export const KIND_DOT_BG: Record<ScheduleKind, string> = {
  insurance: "bg-amber-500",
  deliverable: "bg-sky-500",
  milestone: "bg-fuchsia-500",
  meeting: "bg-brand-500",
  kpi: "bg-teal-500",
};

export const KIND_LABEL: Record<ScheduleKind, string> = {
  insurance: "Insurance",
  deliverable: "Deliverable",
  milestone: "Milestone",
  meeting: "Meeting",
  kpi: "KPI",
};

export const KIND_LABEL_PLURAL: Record<ScheduleKind, string> = {
  insurance: "Insurances",
  deliverable: "Deliverables",
  milestone: "Milestones",
  meeting: "Meetings",
  kpi: "KPIs",
};
